export default "__VITE_ASSET__c3ad739d__"